import { render } from "./Potus.vue?vue&type=template&id=3f1cdbee"
import script from "./Potus.vue?vue&type=script&lang=js"
export * from "./Potus.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__